import { Injectable } from "@angular/core";
import { EdpResponseBody } from "@edp-models/response.model";
import { IUserNotification } from "@edp-models/user-notification.model";
import { ApiService } from "@edp-services/api.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class UserService {
    constructor(private apiService: ApiService) { }

    public getAll(): Observable<IUserNotification[] | Error> {
        return this.apiService.callServicePostToCollection<IUserNotification[]>(`userNotifications.getAll`, {});
    }

    public markRead(notificationId: string): Observable<boolean | Error> {
        return this.apiService
            .callServicePost(`userNotifications.markRead`, {
                Id: notificationId,
            })
            .pipe(
                map((response: EdpResponseBody | Error) => {
                    return response instanceof Error ? response : response.Success;
                })
            );
    }

    public markAllViewed(): Observable<boolean | Error> {
        return this.apiService.callServicePost(`userNotifications.markViewed`, {}).pipe(
            map((response: EdpResponseBody | Error) => {
                return response instanceof Error ? response : response.Success;
            })
        );
    }

    public welcomeViewed(): Observable<any> {
        return this.apiService.callServicePostToCollection("EdpE.action", { action: "WELCOME_SCREEN", status: true });
    }

    public edpESubscribed(payload): any {
        return this.apiService.callServicePostToCollection("EdpE.action", { action: "EDPE_SUB", status: true, code: payload.code });
    }

    public edpESubViewed(): Observable<any> {
        return this.apiService.callServicePostToCollection("EdpE.action", { action: "EDPE_SCREEN", status: true });
    }

    public setUserLevelStatus(levelChange) {
        return this.apiService.callServicePost("EdpE.action", { action: "LEVEL_CHANGE", status: true, levelChange });
    }

    public markPlanetAnniversaryAsRead() {
        return this.apiService.callServicePost("EdpE.action", { action: "YEAR_CHANGE", status: true });
    }

    public markVideoOnboardingAsViewed(): Observable<any> {
        return this.apiService.callServicePost("EdpE.action", { action: "WELCOME_VIDEO", status: true });
    }

    public getCounter(): Observable<any> {
        return this.apiService.callServicePost("userPoint.getCounter", {});
    }

    public setViewToastLocalReception(args) {
        return this.apiService.callServicePost("usersession.viewToastLocalReception", {loginNr: args});
    }

    public getProfileStatus(): Observable<any> {
        return this.apiService.callServicePost("user.profileStatus", {});
    }
    public acceptTerm(): Observable<any> {
        return this.apiService.callServicePost("usersession.updateLoginTerm", {});
    }
}
